import React from 'react';

interface FilterOptionProps {
    condition: string;
    isActive: boolean;
    onClick: (condition: string) => void;
    count: any
}

const QuotationTabs = ({ condition, isActive, onClick, count }: FilterOptionProps) => {
    return (
        <span
            onClick={() => onClick(condition)}
            role="button"
            tabIndex={0}
            className={`py-1 px-2 sm:px-10 lg:px-5 font-medium w-full text-center text-[10px] sm:text-[14px] cursor-pointer rounded-full sm:rounded-md transition-all duration-200 ease-in-out text-nowrap flex justify-center gap-1 capitalize ${
            isActive
                ? "text-white bg-[#182A70]"
                : "text-gray-600 hover:text-[#182A70] bg-transparent"
            }`}
        >
            {condition} {`(${count ?? 0})`}
        </span>
    );
};

export default QuotationTabs;
